import single from './single';
import tree from './group-by-contract-view';
import {Moment} from "moment";
import {useContext} from "react";
import {GlobalAppStateContext} from "../../../../context/global-app-state";
import {useFlightsTableFeatureFlags} from "../feature-flags";

export interface TableViewsContext {
    currentTime?: Moment;
}

export function useTableViews(dataSource: any[], context: TableViewsContext){
    const globalAppState = useContext(GlobalAppStateContext);
    const tableSettings = globalAppState.getTableSettings('liveFlights');

    const featureFlags = useFlightsTableFeatureFlags();

    const groupBy = tableSettings?.settings?.groupBy || featureFlags.preferredGroupBy;

    if (!dataSource) return [];

    switch (groupBy){
        case 'contract':
            return tree(dataSource, context);
        default:
            return single(dataSource, context);
    }
}